/**
 * Brand mark for auth screens, built from the SmartPay Utilities logo.
 */
import appIcon from '../assets/brand/app-icon.png';
import logoWordmark from '../assets/brand/logo-wordmark.png';

export const APP_BRAND_NAME = 'SMARTPAY UTILITIES';

export function AppBrandLogo({ banner = false, className = '' }) {
  if (banner) {
    return (
      <div
        className={`w-full rounded-2xl bg-white shadow-lg shadow-[#99E1D9]/40 py-4 px-4 flex items-center justify-center ${className}`}
      >
        <img
          src={logoWordmark}
          alt="SmartPay Utilities"
          className="h-36 w-auto max-w-full object-contain"
        />
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center gap-2 mx-auto ${className}`}>
      <img src={appIcon} alt="SmartPay Utilities" className="w-20 h-20 rounded-2xl shadow-lg shadow-primary/30" />
    </div>
  );
}

export default AppBrandLogo;
